import {logger} from './logger';

type DisposerFn = () => void;

interface Disposable {
  dispose(): void;
}

type OnDisposeType = DisposerFn | Disposable;

function isDisposerFn(value: OnDisposeType): value is DisposerFn {
  return typeof value === 'function';
}

function isDisposable(value: OnDisposeType): value is Disposable {
  return typeof (value as Disposable).dispose === 'function';
}

export class Disposers implements Disposable {
  private disposers: (() => void)[] = [];

  add = (...disposers: OnDisposeType[]) => {
    if (disposers === null || disposers === undefined)
      return;
    for (const value of disposers) {
      if (value === null || value === undefined)
        return;

      if (isDisposerFn(value))
        this.disposers.push(value);
      if (isDisposable(value))
        this.disposers.push(() => value.dispose());
    }
  };

  dispose = () => {
    for (let disposer of this.disposers)
      try {
        disposer();
      } catch (e) {
        logger.error(e);
      }
    this.disposers.length = 0;
  };
}
